import {useStore} from './useStore';

export const useCategoriesFilterCount = () : number => {
    const filters = useStore( store => store.ui.categories);

    let activeFilterCount = 0;
    if (filters.searchFilter) {
        activeFilterCount++;
    }

    return activeFilterCount;
}